// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic

// styles
import './styles/graphic.scss';

/* develblock:start */

import * as d3 from 'd3';
import { format } from 'd3-format';
import meta from './data/meta.json';
import { stylePremium } from './utils/helpers';
import { bandAxis, linearAxis } from '../../../factory/axes';

import './styles/graphic.scss';

// formatD3Time();
d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

const fmtComma = format(',');
const fmtSI = format('.1s');
const fmtThou = format('~s');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


let minValue;
let maxValue;


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let data;

// Load the JSON file and update the page elements
d3.json('https://ix.cnn.io/data/measles/toplines_measles_cases.json')
  .then((data) => {
    // Extract the single object from the array
    const { summary, last_updated_str } = data[0];

    // Append the summary to the "dek" element
    d3.select('.dek').html(summary);

    d3.select('#timestamp').html(`Note: Current year case figures are preliminary. Data current as of ${last_updated_str}`);
  })
  .catch(error => console.error('Error loading JSON:', error));

d3.json('https://ix.cnn.io/data/measles/annual_measles_cases.json').then((jsondata) => {
  data = jsondata.map(
    (d, i) => ({
      year: +d.year,
      cases: +d.cases,
    }),
  )
    .sort((a, b) => a.year - b.year);

  minValue = Math.min(0, d3.min(data, d => d.cases));
  maxValue = d3.max(data, d => d.cases) * 1.2;

  draw();

  window.onresize = draw;
});


function draw() {
  const container = d3.select('#graphic');
  container.html('');


  const initialWidth = container.node().clientWidth;
  const initialHeight = 400;
  const isMobile = initialWidth <= 500;

  const margins = {
    top: 30,
    right: 20,
    bottom: 25,
    left: (isMobile) ? 40 : 40,
  };

  const width = initialWidth - margins.right - margins.left;


  const height = 400;
  const padding = 0.15;


  const chartHeight = height - margins.top - margins.bottom;
  const chartWidth = initialWidth - margins.left - margins.right;

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, chartWidth],
    domain: data.map(d => d.year),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [chartHeight, 0],
    domain: [Math.min(0, minValue), maxValue],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  const xTicks = isMobile ? 5 : 5;
  const yTicks = isMobile ? 5 : 5;

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', height);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const formatMonth = d3.timeFormat('%b');

  // Decide how many x-axis ticks we want
  const xTickCount = isMobile ? 5 : 10;
  // Calculate the "skip" interval based on total data length
  const skipValue = Math.ceil(data.length / xTickCount);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(0, ${chartHeight})`)
    .call(
      xAxis(x)
        .tickValues(x.domain().filter((d, i) => i % skipValue === 1))
        .tickFormat(d => d)
        .tickSize(6),
    );


  xGrid.selectAll('text')
    .attr('y', 10);

  xGrid.selectAll('line')
    .attr('stroke', '#999');

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtThou(d).toUpperCase()
          : fmtComma(d)
        )
        : (Math.abs(d) > 9999 * 100000
          ? fmtThou(d).toUpperCase()
          : fmtComma(d)
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0 && minValue >= 0)
    .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  const bars = group.append('g')
    .attr('class', 'bars');

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.year), y(d.cases < 0 ? 0 : d.cases)]})`);

  bar.append('title')
    .text(d => `${d.year}: (${fmtComma(d.cases)})`);

  bar.append('rect')
    .attr('class', d => (+d.cases < 0 ? 'loss' : ''))
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.cases) - y(0)));

  bar.append('text')
    .attr('class', 'value in')
    .attr('role', 'listitem')
    .attr('x', x.bandwidth() / 2)
    .attr('dy', d => ((d.cases > y.domain()[1] * 0.9)
      ? '1.1em'
      : '-.5em'))
    .attr('text-anchor', 'middle')
    .attr('stroke', 'white')
    .attr('stroke-width', 3)
    .attr('stroke-linejoin', 'round')
    .attr('stroke-linecap', 'round')
    .attr('paint-order', 'stroke')
    .text(d => (isMobile
      ? (Math.abs(d.cases) > 999
        ? fmtThou(d.cases).toUpperCase()
        : fmtComma(d.cases)
      )
      : (Math.abs(d.cases) > 9999
        ? fmtThou(d.cases).toUpperCase()
        : fmtComma(d.cases)
      )));

  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }

  // Highlight the 2025 bar with an annotation
  const highlightYear = 2025;
  const highlightData = data.find(d => d.year === highlightYear);

  if (highlightData) {
    const annotationGroup = g.append('g')
      .attr('class', 'annotation-group');

    // Draw a horizontal line from the bar to the left
    const lineStartX = x(highlightYear);
    const lineEndX = x(highlightYear) - 10;
    const lineY = y(highlightData.cases) + 5; // pegged to top of bar with small offset down

    annotationGroup.append('line')
      .attr('class', 'annotation-line')
      .attr('x1', lineStartX)
      .attr('y1', lineY)
      .attr('x2', lineEndX)
      .attr('y2', lineY)
      .attr('stroke', '#999')
      .attr('stroke-width', 1);

    // Show the year
    annotationGroup.append('text')
      .attr('class', 'annotation-date')
      .attr('x', lineEndX - 5)
      .attr('y', lineY - 15)
      .attr('text-anchor', 'end')
      .attr('stroke', 'white')
      .attr('stroke-width', 3)
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('paint-order', 'stroke')
      .text(highlightYear);

    // Show the annotation text
    const annotationText = annotationGroup.append('text')
      .attr('class', 'annotation-value')
      .attr('x', lineEndX - 5)
      .attr('y', lineY)
      .attr('text-anchor', 'end')
      .attr('stroke', 'white')
      .attr('stroke-width', 3)
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('paint-order', 'stroke');

    if (isMobile) {
      annotationText.append('tspan')
        .attr('x', lineEndX - 5)
        .attr('dy', 0)
        .text('Texas outbreak');
      annotationText.append('tspan')
        .attr('x', lineEndX - 5)
        .attr('dy', '1.1em')
        .text('led to spike in US cases');
    } else {
      annotationText.text('Texas outbreak led to spike in US cases');
    }
  }


  window.pymChild.sendHeight();

  d3.select('#root')
    .attr('class', 'ready');
}
